import { HttpResult } from 'widgets-for-react'
import { SpecialistPage } from '../cmsPage/cmsPageState'
import { transformSpecialistPageData } from '../cmsPage/sharepointPageApi/transformers/pageDataToPage'
import { SpecialistPageData } from '../cmsPage/sharepointPageApi/types/pageData'

export const getSpecialistOverviewData = async (): Promise<HttpResult<SpecialistPage[]>> => {
  const res = await fetch('/api/v1/pages/specialists')

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  document.title = 'Specialisten | Spaarne Gasthuis'

  const data: SpecialistPageData[] = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data.map((item) => transformSpecialistPageData(item)),
  }
}
